import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0cebed62"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "anchor" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SwiperSlide = _resolveComponent("SwiperSlide")!
  const _component_Swiper = _resolveComponent("Swiper")!
  const _component_LeftOutlined = _resolveComponent("LeftOutlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_RightOutlined = _resolveComponent("RightOutlined")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Swiper, {
        slidesPerView: "auto",
        speed: 600,
        navigation: {prevEl:'.button_prev',nextEl:'.button_next',disabledClass:'button_disabled'}
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.expand.anchor, (item, index) => {
            return (_openBlock(), _createBlock(_component_SwiperSlide, null, {
              default: _withCtx(() => [
                _createElementVNode("a", {
                  class: _normalizeClass({active:index===0}),
                  onClick: ($event: any) => (_ctx.$router.push({hash:item.hash}))
                }, _toDisplayString(item.title), 11 /* TEXT, CLASS, PROPS */, _hoisted_3)
              ]),
              _: 2 /* DYNAMIC */
            }, 1024 /* DYNAMIC_SLOTS */))
          }), 256 /* UNKEYED_FRAGMENT */))
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["navigation"]),
      _createVNode(_component_a_button, {
        type: "link",
        class: "button_prev"
      }, {
        icon: _withCtx(() => [
          _createVNode(_component_LeftOutlined)
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_a_button, {
        type: "link",
        class: "button_next"
      }, {
        icon: _withCtx(() => [
          _createVNode(_component_RightOutlined)
        ]),
        _: 1 /* STABLE */
      })
    ])
  ]))
}